import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { LogoPublic } from '../components/Logo';

/**
 * Landing page after successful Stripe Checkout for trial activation.
 * Shows success message, then redirects to dashboard.
 */
export const TrialActivated = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/dashboard', { replace: true }), 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <LogoPublic size="lg" />
        </div>

        <Card className="border-border shadow-sm">
          <CardHeader className="text-center space-y-3">
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto">
              <CheckCircle2 className="w-8 h-8 text-green-600" />
            </div>
            <CardTitle className="text-2xl font-bold font-heading">
              Trial activated!
            </CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <p className="text-muted-foreground">
              Your 14-day free trial is now active. You have full access to all features.
              You will not be charged until your trial ends.
            </p>
            <Button
              onClick={() => navigate('/dashboard', { replace: true })}
              className="w-full h-12 text-base font-bold"
              data-testid="go-dashboard-btn"
            >
              Go to Dashboard <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <p className="text-xs text-muted-foreground">
              Redirecting automatically in a few seconds...
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
